'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSnapshotFormId = exports.getSnapshotFormId = function getSnapshotFormId(formId) {
  return formId + '-snapshot';
};